











































import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { dayjs, DTW_FORMAT_JA, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import TransferIcon from '../../components/icon/TransferIcon.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import { LessonsService } from '../../biz/remote/LessonsService';
import { Session } from '../../utils/Session';
import { routeHelper } from '../../utils/routeHelper';
import TransferDialog from '../components/TransferDialog.vue';

@Component({
  components: { CommonDialog, TransferIcon, TransferDialog },
  filters: {
    dateFormat(value: string): string {
      if (!value) return '';
      return dayjs(value).format(DTW_FORMAT_JA);
    },
  },
})
export default class LessonResevationCommitDialog extends Vue {
  private dto = new LessonDTO();
  private start_dt = '';
  private nickname = '';
  // 振替ボタンが押された行
  private transferRow: LessonDTO = new LessonDTO();

  private get title() {
    return `${this.nickname} `; // ${this.start_dt}
  }

  /**
   * 確定
   */
  async commit(row: LessonDTO) {
    // MessageDialog.
    const isOK = await MessageDialog.confirm(`${row.student?.nickname}さんの${dayjs(row.lessons?.start_dt).format(DT_FORMAT_JA)}開始の予約を確定します。よろしいですか？`);

    if (isOK) {
      const biz = new LessonsService();
      row.commit = true;
      const response = await biz.reservationCommit(row.lessons, Session.getSessionBuildingId());
      if (response.hasError) {
        MessageDialog.alert(response.errorDescription);
        return;
      }
      // カレンダーから削除
      this.$emit('commit', row);
      this.close();
    }
  }

  /**
   * 個人別支援計画
   */
  showPersonalPlan(student_user_id: string) {
    routeHelper(this, 'SupportPlanPageFroTeacher', { user_id: student_user_id });
  }

  /**
   * 振替処理
   */
  async change(row: LessonDTO, index: number) {
    this.transferRow = row;
    if (!row.lessons?.start_dt) {
      MessageDialog.systemError('授業予定日', '振替ダイアログ表示時', row.lessons?.start_dt).then();
      return;
    }
    const dt = row.lessons.start_dt;
    const dialog: TransferDialog = this.$refs['dialog'] as TransferDialog;
    dialog.show(dt, row);
  }

  /**
   * 振替後のカレンダー除去
   */
  transfered(row: LessonDTO) {
    // カレンダーから削除
    this.$emit('commit', row);
    this.close();
  }

  /**
   * ダイアログを開く
   */
  public async show(dto: LessonDTO) {
    this.dto = dto;
    this.start_dt = dayjs(this.dto.lessons.start_dt).format(DTW_FORMAT_JA);
    this.nickname = this.dto.student?.nickname || '';
    await (this.$refs['reservation_commit_dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['reservation_commit_dialog'] as CommonDialog).hide();
  }
}
